<div
	class="absolute top-0 left-0 flex items-center justify-center w-13 h-13 rounded-full text-lg uppercase border border-gray-300 text-gray-600 dark:bg-gray-700 dark:text-gray-200 z-20">
	<i class="pi pi-spin pi-spinner"></i>
</div>

<img
	(load)="hideLoaderSuccess()"
	(error)="hideLoaderError()"
	[src]="image"
	class="absolute top-0 left-0 w-13 h-13 rounded-full object-cover border-2 border-gray-300 drop-shadow-md z-20"
	alt="" />

<div
	*ngIf="isAvatarDefault"
	class="absolute top-0 left-0 flex items-center justify-center w-13 h-13 rounded-full text-lg uppercase border-2 border-gray-300 bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 z-30">
	{{ value.charAt(0) | titlecase }}
</div>
